import { html, ref } from "@microsoft/fast-element";
/**
 * The template for the {@link @fabric-msft/fabric-web#(Card:class)} component.
 * @public
 */
export function cardTemplate() {
    return html `
    <template
      orientation="${(x) => x.orientation}"
      appearance="${(x) => x.appearance}"
      ?interactive="${(x) => x.interactive}"
    >
      <div
        role="${(x) => (x.interactive ? "button" : "group")}"
        class="card"
        tabindex="${(x) => (x.isFocusable ? "0" : null)}"
        @click="${(x, c) => x.clickHandler(c.event)}"
        @keydown="${(x, c) => x.keydownHandler(c.event)}"
        aria-label="${(x) => x.ariaLabel}"
        aria-labelledby="${(x) => x.ariaLabelledby}"
        aria-describedby="${(x) => x.ariaDescribedby}"
        aria-disabled="${(x) => x.interactive ? (x.disabled ? "true" : "false") : null}"
        ${ref("card")}
      >
        <div class="root" ${ref("root")}>
          <div class="content">
            <slot></slot>
          </div>
        </div>
      </div>
    </template>
  `;
}
export const template = cardTemplate();
//# sourceMappingURL=card.template.js.map